<template>
  <div class="media-uploader">
    <div class="uploader-content fit-content overflow-auto ">
      <div class="media-header  border-outline-dark-bottom">
        <div>
          <h1
            class="d-flex justify-content-start align-items-center"
          >
            <span>Select date &amp; time</span>
          </h1>
        </div>
        <button
          class="btn-close btn-light"
          @click="close"
          data-placement="top"
          @mouseover="helper.showTooltip"
          @mouseleave="helper.hideTooltip"
          title="Close"
        >
          &times;
        </button>
      </div>
      <div class="media-container p-4 overflow-hidden">
        <v-date-picker
          class="d-block mx-auto"
          :value="selectedDate"
          mode="dateTime"
          trim-weeks
          @input="dateInputChange"
        />
      </div>
      <div class="media-footer  border-outline-dark-top">
        <button
          class="btn btn-outline-secondary btn-sm"
          @click="close"
          data-placement="top"
          @mouseover="helper.showTooltip"
          @mouseleave="helper.hideTooltip"
          title="Click to cancel"
        >
          Cancel
        </button>
        <button
          class="btn btn-primary btn-sm"
          @click="dateSelected"
          data-placement="top"
          @mouseover="helper.showTooltip"
          @mouseleave="helper.hideTooltip"
          title="Click to apply"
        >
          Apply
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import helper from "@/helper";

export default {
  name: "date-time-selector",
  props: ["date"],
  data() {
    return {
      selectedDate: null,
      helper: helper,
    };
  },
  methods: {
    dateInputChange(e) {
      this.selectedDate = e;
    },
    dateSelected() {
      if (this.selectedDate === null) {
        Swal.fire("", "Please select valid date", "warning");
      } else {
        this.$emit("close", this.selectedDate);
      }
    },
    close() {
      this.$emit("close");
    },
  },
  mounted() {
    this.selectedDate = this.date;
  },
};
</script>